import { cn } from '@nexelem/utils';
import type { ComponentPropsWithoutRef, ElementType } from 'react';
import { DrawerContent } from './DrawerContent';
import { DrawerError } from './DrawerError';
import { DrawerFooter } from './DrawerFooter';
import { DrawerHeader } from './DrawerHeader';
import { DrawerPanel } from './DrawerPanel';

type DrawerProps<T extends ElementType> = {
  component?: T;
} & ComponentPropsWithoutRef<T>;

export const Drawer = <T extends ElementType = 'div'>({ children, className, component, ...rest }: DrawerProps<T>) => {
  const Component = component || 'div';

  return (
    <Component
      className={cn(
        'relative flex h-full flex-col border-border-primary bg-surface-primary group-[.drawer-left]:border-r group-[.drawer-right]:border-l',
        className,
      )}
      {...rest}
    >
      {children}
    </Component>
  );
};

Drawer.Header = DrawerHeader;
Drawer.Content = DrawerContent;
Drawer.Footer = DrawerFooter;
Drawer.Panel = DrawerPanel;
Drawer.Error = DrawerError;
